"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_LOCATION = exports.RECENT_DEST = exports.ROLES = exports.AUTHORIZATION_INFO = void 0;
exports.AUTHORIZATION_INFO = "autorization_info";
exports.ROLES = "roles";
exports.RECENT_DEST = "recent_destination";
exports.DEFAULT_LOCATION = {
    lat: 35.69978096472337,
    lng: 51.33803091522215,
};
